import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { graphicDataColor1 } from "../../../../../config/constants";
import { levelsByProtocol } from "../../../functions";
// Components
import PlotWithLevels from "../plotWithLevels";

const SuccessRatePlot = ({ sessions }) => {
  const [currentLevel, setCurrentLevel] = useState("total");
  const [levels] = useState(new Array(levelsByProtocol).fill(0).map((_, i) => i));
  const [positions, setPositions] = useState([]);
  const [successRateValues, setSuccessRateValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let successRateValues = [];

    sessions.forEach((session, i) => {
      positions.push(i + 1);

      let totalHits = "-";
      let totalErrors = "-";

      let targetedLevels = isNaN(currentLevel) ? levels : [currentLevel];

      for (const level of targetedLevels) {
        const hits = session.hasOwnProperty(`totalHits_level${level}`)
          ? Number(session[`totalHits_level${level}`])
          : session.hasOwnProperty(`totalErrors_level${level}`)
          ? 0
          : "-";

        const errors = session.hasOwnProperty(`totalErrors_level${level}`)
          ? Number(session[`totalErrors_level${level}`])
          : session.hasOwnProperty(`totalHits_level${level}`)
          ? 0
          : "-";

        if (!isNaN(hits) && !isNaN(errors)) {
          totalHits = isNaN(totalHits) ? hits : hits + totalHits;
          totalErrors = isNaN(totalErrors) ? errors : errors + totalErrors;
        }
      }

      const successRate = isNaN(totalHits) || isNaN(totalErrors) ? NaN : parseInt((totalHits / (totalHits + totalErrors)) * 100);
      successRateValues.push(successRate);
    });

    setPositions(positions);
    setSuccessRateValues(successRateValues);

    return () => {
      setPositions([]);
      setSuccessRateValues([]);
    };
  }, [sessions, currentLevel, levels]);

  const Data = {
    labels: positions,
    datasets: [
      {
        data: successRateValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
    ],
  };

  return (
    <PlotWithLevels
      title={t("rgsicu_successRate")}
      data={Data}
      axisY={`${t("rgsicu_successRate")} (%)`}
      axisX={t("sessions")}
      max={100}
      showLegend={false}
      currentLevel={currentLevel}
      setCurrentLevel={setCurrentLevel}
    />
  );
};

export default SuccessRatePlot;
